import { PackingCategoryEnum } from "@gtpl/shared-models/common-models"
import { FixedComponentsCategoryEnum } from "./category-enum"

export class FixedComponentsRateChartRequest{
    id:number
    component:string
    price:number
    createdUser:string
    updatedUser:string
    isActive:boolean
    versionFlag:number
    createdAt:Date
    category:FixedComponentsCategoryEnum
    packingCategory: PackingCategoryEnum
    constructor(
    id:number,
    component:string,
    price:number,
    createdUser:string,
    updatedUser:string,
    isActive:boolean,
    versionFlag:number,
    createdAt:Date,
    category:FixedComponentsCategoryEnum,
    packingCategory: PackingCategoryEnum
    ){
       this.id = id
       this.component = component
       this.price = price
       this.createdUser = createdUser
       this.updatedUser = updatedUser
       this.isActive = isActive
       this.versionFlag = versionFlag
       this.createdAt = createdAt
       this.category = category
       this.packingCategory = packingCategory
    }
}